import type { PropsWithChildren, ReactNode } from 'react'

interface PageSectionProps extends PropsWithChildren {
  badge?: string
  eyebrow?: string
  title: string
  description?: string
  actions?: ReactNode
  className?: string
  contentClassName?: string
}

export default function PageSection({
  badge,
  eyebrow,
  title,
  description,
  actions,
  className = '',
  contentClassName = '',
  children,
}: PageSectionProps) {
  return (
    <section className={`section-shell ${className}`}>
      <div className={`mx-auto max-w-6xl ${contentClassName}`}>
        <div className="max-w-3xl">
          {badge ? <span className="section-badge">{badge}</span> : null}
          {eyebrow ? <p className="section-eyebrow">{eyebrow}</p> : null}
          <h2 className="section-title">{title}</h2>
          {description ? <p className="section-copy">{description}</p> : null}
          {actions ? <div className="mt-8 flex flex-wrap gap-4">{actions}</div> : null}
        </div>
        {children ? <div className="mt-12">{children}</div> : null}
      </div>
    </section>
  )
}
